export default __webpack_public_path__ + "static/media/polisan.9518c171.jpg";